import React, { useCallback, Fragment } from 'react';
import { CUSTOM_FIELDS_TYPE, ALL_MODULES } from '@nile/components';
import CustomTextField from './CustomFieldInputs/CustomTextField';
import CustomSelectField from './CustomFieldInputs/CustomFieldSelect';
import CustomCheckBox from './CustomFieldInputs/CustomChekboxField';
import CustomRadioField from './CustomFieldInputs/CustomRadioField';
import CustomDateTimeField from './CustomFieldInputs/CustomDateTimeField';
import CustomSecureTextField from './CustomFieldInputs/CustomSecureTextField';

const CustomFieldsInput = (props) => {
  const {
    field,
    onChange,
    value,
    noPortalTarget,
    customLabelComponent,
    ticket,
    fields,
    customTextFieldUIProps,
    customTextFieldLabel,
    datePickerPortalId
  } = props;
  const { fieldType, label } = field;

  const getCustomFieldInput = useCallback(() => {
    switch (fieldType) {
      case CUSTOM_FIELDS_TYPE.TEXT:
      case 'text':
        return (
          <Fragment key={field?.id}>
            <CustomTextField
              field={field}
              value={value}
              onChange={onChange}
              key={field?.label}
              customTextFieldUIProps={customTextFieldUIProps}
              customTextFieldLabel={customTextFieldLabel}
            />
          </Fragment>
        );
      case CUSTOM_FIELDS_TYPE.PARAGRAPH:
      case 'paragraph':
        return (
          <Fragment key={field?.id}>
            <CustomTextField
              field={field}
              multiline={4}
              value={value}
              onChange={onChange}
              key={field?.label}
              customTextFieldUIProps={customTextFieldUIProps}
              customTextFieldLabel={customTextFieldLabel}
            />
          </Fragment>
        );
      case CUSTOM_FIELDS_TYPE.NUMERIC:
      case 'numeric':
        return (
          <Fragment key={field?.id}>
            <CustomTextField
              field={field}
              type="number"
              value={value}
              onChange={onChange}
              key={field?.label}
              customTextFieldUIProps={customTextFieldUIProps}
              customTextFieldLabel={customTextFieldLabel}
            />
          </Fragment>
        );
      case CUSTOM_FIELDS_TYPE.DECIMAL:
      case 'decimal':
        return (
          <Fragment key={field?.id}>
            <CustomTextField
              field={field}
              type="number"
              inputMode="decimal"
              value={value}
              onChange={onChange}
              key={field?.label}
              customTextFieldUIProps={customTextFieldUIProps}
              customTextFieldLabel={customTextFieldLabel}
            />
          </Fragment>
        );
      case CUSTOM_FIELDS_TYPE.SELECT:
      case 'select':
        return (
          <>
            <Fragment key={field?.id}>
              <CustomSelectField
                field={field}
                value={value}
                onChange={onChange}
                noPortalTarget={noPortalTarget}
                customLabelComponent={customLabelComponent}
                ticket={ticket}
                fields={fields}
              />
            </Fragment>
          </>
        );
      case CUSTOM_FIELDS_TYPE.MULTI_SELECT:
      case 'multiSelect':
        return (
          <Fragment key={field?.id}>
            <CustomSelectField
              field={field}
              value={value}
              onChange={onChange}
              isMulti
              noPortalTarget={noPortalTarget}
              customLabelComponent={customLabelComponent}
            />
          </Fragment>
        );
      case CUSTOM_FIELDS_TYPE.CHECKBOX:
      case 'checkbox':
        return (
          <Fragment key={field?.id}>
            <CustomCheckBox field={field} value={value} onChange={onChange} />
          </Fragment>
        );
      case CUSTOM_FIELDS_TYPE.RADIO:
      case 'radio':
        return (
          <Fragment key={field?.id}>
            <CustomRadioField
              field={field}
              value={value}
              onChange={onChange}
              ticket={ticket}
              fields={fields}
            />
          </Fragment>
        );
      case CUSTOM_FIELDS_TYPE.DATE:
      case 'date':
      case CUSTOM_FIELDS_TYPE.DATETIME:
      case 'datetime':
        return (
          <Fragment key={field?.id}>
            <CustomDateTimeField
              field={field}
              value={value}
              onChange={onChange}
              portalId={datePickerPortalId}
            />
          </Fragment>
        );
      case 'SECURE_TEXT':
      case CUSTOM_FIELDS_TYPE.SECURE_TEXT:
        return (
          <Fragment key={field?.id}>
            <CustomSecureTextField
              module={ALL_MODULES.ticket}
              field={field}
              value={value}
              updateSelection={onChange}
            />
          </Fragment>
        );

      default:
        return null;
    }
  }, [field, fields]);

  return (
    <React.Fragment key={`${ticket.ticketId}.${field?.id}`}>
      {getCustomFieldInput()}
    </React.Fragment>
  );
};

export default CustomFieldsInput;
